import { Link } from "react-router-dom";
import { Verified, Bitcoin, ArrowUpRight } from "lucide-react";
import { useFx } from "../lib/fx";

const PRICE_LABELS = {
  fixed: "fixed",
  from: "from",
  per_hour: "per hour",
  per_day: "per day",
  per_person: "per person",
  custom_quote: "on request",
};

export default function ServiceCard({ s, category }) {
  const { format, userCurrency } = useFx();
  const img = (s.images && s.images[0]) ||
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";
  const showNative = userCurrency !== s.currency;
  return (
    <Link to={`/services/${s.id}`} className="luxe-card group block" data-testid={`service-card-${s.id}`}>
      <div className="relative aspect-[5/4] overflow-hidden">
        <img src={img} alt={s.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {s.is_featured && <span className="chip info">Featured</span>}
          {s.crypto_accepted && <span className="chip"><Bitcoin size={10}/> Crypto</span>}
        </div>
        <div className="absolute top-3 right-3">
          {s.verified && <span className="chip success"><Verified size={10}/> Verified</span>}
        </div>
      </div>
      <div className="p-5">
        {category && <div className="eyebrow !text-[10px]">{category.name}</div>}
        <h3 className="font-serif-display text-2xl mt-1 leading-tight text-bone">{s.title}</h3>
        <p className="mt-2 text-xs text-muted line-clamp-2">{s.description}</p>
        <div className="divider-x my-4"/>
        <div className="flex items-baseline justify-between">
          <div>
            <div className="label-tiny">{PRICE_LABELS[s.price_type] || ""}</div>
            <div className="font-serif-display text-2xl text-bone">{format(s.base_price, s.currency)}</div>
            {showNative && (
              <div className="text-[11px] text-muted/70 font-mono">≈ {format(s.base_price, s.currency, { native: true })}</div>
            )}
          </div>
          <div className="flex items-center gap-1 text-teal text-sm">
            View <ArrowUpRight size={14}/>
          </div>
        </div>
      </div>
    </Link>
  );
}
